module.exports = __webpack_public_path__ + "img/legal-document-edit.895f5b36.png";